import { Loader2 } from "lucide-react";

export const RootPendingComponent = () => {
  return (
    <main
      className="flex flex-1 items-center justify-center px-4 py-16"
      role="status"
      aria-label="Loading"
      aria-live="polite"
    >
      <Loader2 className="size-10 animate-spin text-muted-foreground" aria-hidden="true" />
    </main>
  );
};
